import { makeStyles } from '@material-ui/core';

export default makeStyles({
  form: {
    marginLeft: '10%',
    marginTop: 16,
    marginBottom: 16,
  },
  corner: {
    width: 10,
    height: 20,
    borderWidth: '0px 0px 1px 1px',
    marginRight: '18px',
    display: 'inline-block',
  },
  corner1: {
    marginLeft: 46,
  },
  'corner.edit.1': {
    marginLeft: 20,
  },
  'corner.edit.2': {
    marginLeft: 32,
  },
  'corner.edit.3': {
    marginLeft: 64,
  },
  corner2: {
    marginLeft: 78,
  },
  corner3: {
    marginLeft: 110,
  },
  dentroDeText: {
    fontSize: 15,
  },
  containerButtons: {
    paddingLeft: 0,
    paddingTop: 16,
  },
});
